import React from 'react';
import GaugeComponent from 'react-gauge-component';

export default function AverageCompanyTime() {
    const averageYears = 3.2;
    const averageMonths = Math.round((averageYears % 1) * 12);
    const fullYears = Math.floor(averageYears);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Tempo Médio de Casa
                </h3>
                <p className="text-xs text-gray-600">
                    Permanência média dos colaboradores na empresa
                </p>
            </div>

            {/* Gauge Chart */}
            <div className="h-48 flex items-center justify-center">
                <GaugeComponent
                    value={averageYears}
                    minValue={0}
                    maxValue={10}
                    type="semicircle"
                    arc={{
                        width: 0.15,
                        padding: 0.005,
                        cornerRadius: 3,
                        subArcs: [
                            {
                                limit: 1,
                                color: '#EF4444',
                                showTick: true,
                            },
                            {
                                limit: 2,
                                color: '#F59E0B',
                                showTick: true,
                            },
                            {
                                limit: 4,
                                color: '#10B981',
                                showTick: true,
                            },
                            {
                                limit: 7,
                                color: '#3B82F6',
                                showTick: true,
                            },
                            {
                                color: '#8B5CF6',
                            }
                        ]
                    }}
                    pointer={{
                        color: '#374151',
                        length: 0.80,
                        width: 15,
                    }}
                    labels={{
                        valueLabel: {
                            style: { fontSize: '24px', fill: '#374151', fontWeight: 'bold' },
                            formatTextValue: () => `${fullYears}a ${averageMonths}m`
                        },
                        tickLabels: {
                            type: 'outer',
                            defaultTickValueConfig: {
                                formatTextValue: (value: number) => `${value}a`,
                                style: { fontSize: '10px' }
                            },
                            ticks: [
                                { value: 1 },
                                { value: 2 },
                                { value: 4 },
                                { value: 7 },
                                { value: 10 }
                            ],
                        }
                    }}
                />
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-3 gap-3 pt-3 border-t border-gray-200">
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">6m</div>
                    <div className="text-xs text-gray-500">Tempo Mínimo</div>
                </div>
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">{fullYears}a {averageMonths}m</div>
                    <div className="text-xs text-gray-500">Tempo Médio</div>
                </div>
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">12a</div>
                    <div className="text-xs text-gray-500">Tempo Máximo</div>
                </div>
            </div>
        </div>
    );
} 